export const getElementStyle = (id?: string, active?: boolean, daily?: boolean) => {
  if (!id) return;
  const elementId = daily ? 'daily-scheduler-grid' : 'scheduler-grid';
  const schedulerGrid = document.getElementById(elementId);
  if (!schedulerGrid) return;

  const startSegment = schedulerGrid
    .querySelector(`[data-${daily ? 'daily-' : ''}start='${id}']`)
    ?.getBoundingClientRect();
  const endSegment = schedulerGrid
    .querySelector(`[data-${daily ? 'daily-' : ''}end='${id}']`)
    ?.getBoundingClientRect();
  if (!startSegment || !endSegment) return;
  return {
    width: endSegment?.x + endSegment?.width - startSegment?.x - 4,
    height: active ? 'calc(50%-2px)' : startSegment?.height - 5,
    left: startSegment?.x - startSegment?.left + 2,
  };
};
